module.exports = __webpack_public_path__ + "media/images/icon/icon_grade-fe6b74b3212cddbad6f1c130301cdf76.png";